// extracted by mini-css-extract-plugin
export default {"iconWrap":"ClientDuplicatesPage_iconWrap__P9HaQ","memberRow":"ClientDuplicatesPage_memberRow__Gdz3H"};